<template>
  <div class="create-video-page">

    <!-- 左侧：选择数字人 -->
    <div class="left-panel">
      <h2 class="panel-title">选择数字人</h2>
      <el-tabs v-model="activeTab" class="tabs">
        <!-- 我的形象 -->
        <el-tab-pane label="我的形象" name="my-image">
          <div class="search-bar">
            <el-input v-model="searchValueMy" placeholder="搜索形象名称" clearable>
              <template #prefix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>
          </div>
          <div class="image-grid">
            <div v-for="(image, index) in myImages" :key="index" class="avatar-card"
              :class="{ selected: selectedImage === image }" @click="selectImage(image)">
              <div class="card-inner">
                <!-- 封面容器 -->
                <div class="cover-wrapper">
                  <div class="cover-mask"></div>
                  <img :src="image.coverUrl" class="cover-image" :class="{ horizontal: image.isHorizontal }" />
                  <div class="preview-hover">
                    <el-icon class="play-icon">
                      <VideoPlay />
                    </el-icon>
                  </div>
                </div>

                <!-- 元信息 -->
                <div class="meta-section">
                  <div class="title-wrapper">
                    <h3 class="avatar-title">{{ image.title }}</h3>
                    <el-tag class="pro-tag" type="warning" effect="dark">PRIV
                    </el-tag>
                  </div>
                  <div class="tech-info">
                    <span class="model-type">{{ image.model }}</span>
                    <span class="resolution" :class="`resolution-${image.resolution}`">
                      {{ image.resolution }}
                      <template v-if="image.resolution === '4K'">ULTRA</template>
                      <template v-if="image.resolution === '2K'">PRO</template>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 选中状态 -->
              <div v-if="selectedImage === image" class="selected-mark">
                <el-icon class="check-icon"><Select /></el-icon>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 公共形象 -->
        <el-tab-pane label="公共形象" name="public-image">
          <div class="search-bar">
            <el-input v-model="searchValuePublic" placeholder="搜索公共形象" clearable>
              <template #prefix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>
          </div>
          <div class="image-grid">
            <div v-for="(image, index) in publicImages" :key="index" class="avatar-card"
              :class="{ selected: selectedImage === image }" @click="selectImage(image)">
              <div class="card-inner">
                <!-- 封面容器 -->
                <div class="cover-wrapper">
                  <div class="cover-mask"></div>
                  <img :src="image.coverUrl" class="cover-image" :class="{ horizontal: image.isHorizontal }" />
                  <div class="preview-hover">
                    <el-icon class="play-icon">
                      <VideoPlay />
                    </el-icon>
                  </div>
                </div>

                <!-- 元信息 -->
                <div class="meta-section">
                  <div class="title-wrapper">
                    <h3 class="avatar-title">{{ image.title }}</h3>
                    <el-tag class="free-tag" effect="dark">PUBL</el-tag>
                  </div>
                  <div class="tech-info">
                    <span class="model-type">{{ image.model }}</span>
                    <span class="resolution">4K Ultra</span>
                  </div>
                </div>
              </div>

              <!-- 选中状态 -->
              <div v-if="selectedImage === image" class="selected-mark">
                <el-icon class="check-icon"><Select /></el-icon>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 中间：名称和音频上传 -->
    <div class="center-container">
      <!-- 添加图片 -->
      <div class="top-image">
        <img src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250123/20250123012021a7dc74198.png"
          alt="装饰图片" />
      </div>

      <!-- 中间板块 -->
      <div class="center-panel">
        <el-form ref="form" :model="form" label-position="top" class="form">
          <!-- 名称输入框 -->
          <el-form-item label="名称" style="font-weight: bold;">
            <el-input v-model="form.name" placeholder="请输入视频的名称，方便查找识别"
              style="font-weight: bold;height: 40px;"></el-input>
          </el-form-item>

          <!-- 上传音频文件 -->
          <el-form-item>
            <div class="upload-container">
              <el-upload v-if="!selectedAudio" class="upload-demo" :before-upload="beforeUpload"
                :on-success="handleSuccess" :on-error="handleError" :limit="1" :file-list="fileList" accept=".wav,.mp3">
                <div class="upload-box">
                  <i class="el-icon-upload upload-icon"></i>
                  <p>点击处上传您的音频文件</p>
                  <span>支持格式：wav/mp3，最大 {{ voiceDuration }}秒，{{ voiceSize }}MB</span>
                </div>
              </el-upload>
              <div v-else class="uploaded-audio">
                <p>已使用音频：{{ selectedAudio.title }}</p>
                <el-button type="primary" class="reupload-button" @click="handleReupload">
                  {{ isCustomAudioUploaded ? '重新上传' : '取消选择' }}
                </el-button>
              </div>
            </div>
          </el-form-item>

          <!-- 提交按钮 -->
          <el-form-item>
            <el-button type="primary" :loading="isLoading" class="submit-button" @click="confirmSynthesis">
              确认合成
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 右侧：选择音频 -->
    <div class="right-panel">
      <h2>选择音频</h2>
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-input v-model="searchAudioValue" placeholder="名称" clearable>
          <template #prefix>
            <i class="el-icon-search" style="color: #ccc"></i>
          </template>
        </el-input>
        <el-button type="primary" class="search-button" @click="searchAudio">
          查询
        </el-button>
      </div>
      <!-- 音频选择内容 -->
      <div class="voice-options">
        <div class="voice-card" :class="{ 'is-selected': voice.isSelected }" v-for="(voice, index) in filteredAudioList"
          :key="index" @click="handleVoiceCardClick(index)">
          <div class="play-icon" @click.stop="togglePlay(index)">
            <svg v-if="!voice.isPlaying" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
              <circle cx="28" cy="28" r="28" fill="#FF5C00" />
              <path d="M21.5 20.5c0-1.8 2.1-3 3.6-2l12.5 8.1c1.4.9 1.4 3 0 3.9l-12.5 8.1c-1.5 1-3.6-.1-3.6-2V20.5z"
                fill="#fff" />
            </svg>
            <!-- 播放中的样式 -->
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
              <circle cx="28" cy="28" r="28" fill="#FF5C00" />
              <rect x="20" y="18" width="4" height="20" fill="#fff" />
              <rect x="32" y="18" width="4" height="20" fill="#fff" />
            </svg>
          </div>
          <div class="voice-info">
            <p class="voice-title">{{ voice.title }}</p>
            <p class="voice-tag">配音人员: {{ voice.author }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import axios from "axios";
import config from "@/config.js";
import { auth } from "@/utils/auth.js";
import { ElMessage } from "element-plus";

export default {
  name: "CreateVideo",

  data() {
    return {
      activeTab: "my-image",
      searchValueMy: "",
      searchValuePublic: "",
      searchAudioValue: "", // 音频搜索关键字
      selectedImage: null,
      selectedAudio: null,
      isLoading: false,  // 控制按钮 loading 状态
      form: {
        name: "",
        audio: null,
      },
      myImages: [], // 我的形象数据
      publicImages: [], // 公共形象数据
      audioList: [], // 音频列表
      audioElement: null,
      currentPlayingIndex: null,
      user: auth.getStoredUser(), // 获取当前用户信息
      voiceDuration: 0,      // 新增：音频最大时长
      voiceSize: 0,          // 新增：音频最大大小
      fileList: [],          // 新增：上传文件列表
      isCustomAudioUploaded: false, // 新增上传状态标识

    };
  },
  computed: {
    // 根据搜索关键字过滤音频列表
    filteredAudioList() {
      if (!this.searchAudioValue) {
        return this.audioList;
      }
      return this.audioList.filter(voice =>
        voice.title.toLowerCase().includes(this.searchAudioValue.toLowerCase())
      );
    },
  },
  created() {
    this.loadImages(); // 加载数字人数据
    this.loadAudioList(); // 加载音频数据
    this.fetchvoiceClarityValues(); // 新增：获取音频限制值

  },
  methods: {

    // 获取视频分辨率等级
    async getVideoResolution(videoUrl) {
      return new Promise((resolve) => {
        const video = document.createElement('video')
        video.src = videoUrl
        video.onloadedmetadata = () => {
          const width = video.videoWidth
          if (width >= 3840) return resolve('4K')
          if (width >= 2560) return resolve('2K')
          if (width >= 1920) return resolve('1080P')
          resolve('720P')
        }
        video.onerror = () => resolve('HD') // 降级处理
      })
    },

    // 修改后的加载方法
    async loadImages() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/create_clone_task.php`, {
          action: "get_video_sc",
          user_id: this.user.id,
        });

        const processImages = async (items) => {
          return Promise.all(items.map(async item => {
            const resolution = await this.getVideoResolution(item.video_url)
            return {
              ...item,
              coverUrl: `${item.video_url}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto`,
              isHorizontal: await this.checkIfHorizontal(item.video_url),
              resolution // 新增分辨率字段
            }
          }))
        }

        const data = response.data.data
        this.myImages = await processImages(data.filter(item => item.is_open === 0))
        this.publicImages = await processImages(data.filter(item => item.is_open === 1))
      } catch (error) {
        console.error("加载数字人数据失败:", error)
      }
    },

    // 判断视频是否为横版
    async checkIfHorizontal(videoUrl) {
      return new Promise((resolve) => {
        const video = document.createElement('video');
        video.src = videoUrl;
        video.onloadedmetadata = () => {
          resolve(video.videoWidth > video.videoHeight); // 宽度大于高度则为横版
        };
        video.onerror = () => {
          resolve(false); // 如果无法加载视频，默认不是横版
        };
      });
    },

    // 动态设置封面样式
    getCoverStyle(image) {
      if (image.isHorizontal) {
        return {
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.2))', // 渐变色
        };
      }
      return {}; // 竖版视频不需要额外样式
    },
    // 加载音频数据
    async loadAudioList() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/create_clone_task.php`, {
          action: "get_voice_clone",
          user_id: this.user.id,
        });
        this.audioList = response.data.data.map(item => ({
          ...item,
          isSelected: false,
          isPlaying: false,
        }));
      } catch (error) {
        console.error("加载音频数据失败:", error);
      }
    },
    // 查询我的形象
    async searchMy() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/create_clone_task.php`, {
          action: "search_video_sc",
          user_id: this.user.id,
          keyword: this.searchValueMy,
        });
        this.myImages = response.data.data.filter(item => item.is_open === 0).map(item => ({
          ...item,
          coverUrl: `${item.video_url}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto`,
          blurUrl: `${item.video_url}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto`,
        }));
      } catch (error) {
        console.error("查询我的形象失败:", error);
      }
    },
    // 查询公共形象
    async searchPublic() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/create_clone_task.php`, {
          action: "search_video_sc",
          user_id: this.user.id,
          keyword: this.searchValuePublic,
        });
        this.publicImages = response.data.data.filter(item => item.is_open === 1).map(item => ({
          ...item,
          coverUrl: `${item.video_url}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto`,
          blurUrl: `${item.video_url}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto`,
        }));
      } catch (error) {
        console.error("查询公共形象失败:", error);
      }
    },
    // 查询音频
    async searchAudio() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/create_clone_task.php`, {
          action: "search_voice_clone",
          user_id: this.user.id,
          keyword: this.searchAudioValue,
        });
        this.audioList = response.data.data.map(item => ({
          ...item,
          isSelected: false,
          isPlaying: false,
        }));
      } catch (error) {
        console.error("查询音频失败:", error);
      }
    },
    // 选择数字人
    selectImage(image) {
      this.selectedImage = image;
    },
    // 获取音频时长和大小限制
    async fetchvoiceClarityValues() {
      try {
        const response = await axios.get(`${config.BASE_URL}/pc/api/get_video_clarity_values.php`);
        if (response.data) {
          this.voiceDuration = response.data.voice_duration || 0; // 音频最大时长
          this.voiceSize = response.data.voice_size || 0; // 音频最大大小
        } else {
          ElMessage.error("获取音频限制失败");
        }
      } catch (error) {
        console.error("获取音频限制失败:", error);
        ElMessage.error("获取音频限制失败，请检查网络");
      }
    },
    // 上传前的校验
    async beforeUpload(file) {
      const isVoice = file.type === "audio/mp3" || file.type === "audio/wav";

      const isLtMaxSize = file.size / 1024 / 1024 < this.voiceSize; // 文件大小限制
      const isGtMinSize = file.size / 1024 / 1024 > 0.1; // 文件最小大小（0.1MB）

      // 校验文件类型
      if (!isVoice) {
        ElMessage.error("只能上传 MP3 或 WAV 格式的音频");
        return false;
      }

      // 校验文件大小
      if (!isLtMaxSize) {
        ElMessage.error(`音频大小不能超过 ${this.voiceSize}MB`);
        return false;
      }
      if (!isGtMinSize) {
        ElMessage.error("音频大小不能小于 0.1MB");
        return false;
      }

      // 校验音频时长
      const duration = await this.getVoiceDuration(file);
      if (duration < 5 || duration > this.voiceDuration) {
        ElMessage.error(`音频时长必须在 5s 到 ${this.voiceDuration}s 之间`);
        return false;
      }

      try {
        const signatureData = await this.getUploadSignature();
        const uploadResult = await this.uploadToOSS(file, signatureData);

        if (uploadResult) {
          // 设置专用字段存储上传的音频URL
          this.selectedAudio = {
            title: file.name,
            uploadedUrl: uploadResult.url,  // 改为专用字段
            content: ""
          };
          this.isCustomAudioUploaded = true; // 标记为上传音频
          ElMessage.success("音频上传成功");
          return true;
        }
      } catch (error) {
        // ...错误处理...
      }
      // 获取上传签名
      try {
        const signatureData = await this.getUploadSignature();
        if (!signatureData) {
          ElMessage.error("获取上传签名失败");
          return false;
        }

        // 使用签名上传文件到 OSS
        const uploadResult = await this.uploadToOSS(file, signatureData);
        if (uploadResult) {
          ElMessage.success("音频上传成功");
          return true;
        } else {
          ElMessage.error("音频上传失败");
          return false;
        }
      } catch (error) {
        console.error("上传失败:", error);
        ElMessage.error("音频上传失败，请重试");
        return false;
      }
    },

    // 获取音频时长
    getVoiceDuration(file) {
      return new Promise((resolve, reject) => {
        const audio = document.createElement('audio'); // 创建 audio 元素
        audio.src = URL.createObjectURL(file); // 设置音频文件的 URL
        audio.onloadedmetadata = () => {
          resolve(audio.duration); // 返回音频时长
        };
        audio.onerror = () => {
          reject(new Error("无法读取音频时长")); // 处理错误
        };
      });
    },

    // 获取上传签名
    async getUploadSignature() {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/upload_signature.php`,
          {
            type: 'audio', // 上传类型为音频
          },
          {
            headers: {
              'Content-Type': 'application/json', // 设置请求头
            },
          }
        );

        // 检查接口返回的数据
        if (response.data && response.data.success) {
          // 确保返回的数据包含所有必需的字段
          const requiredFields = ['accessKeyId', 'policy', 'signature', 'bucket', 'endpoint', 'folder'];
          for (const field of requiredFields) {
            if (!response.data[field]) {
              throw new Error(`接口返回数据缺少字段: ${field}`);
            }
          }

          // 返回签名数据
          return response.data;
        } else {
          // 如果接口返回 success 为 false，抛出错误
          throw new Error(response.data.error || "获取上传签名失败");
        }
      } catch (error) {
        console.error("获取上传签名失败:", error);
        throw error;
      }
    },

    // 上传文件到 OSS
    async uploadToOSS(file, signatureData) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("key", `${signatureData.folder}${file.name}`); // 文件路径
        formData.append("policy", signatureData.policy); // 上传策略
        formData.append("OSSAccessKeyId", signatureData.accessKeyId); // AccessKeyId
        formData.append("signature", signatureData.signature); // 签名
        formData.append("success_action_status", "200"); // 上传成功时返回的状态码
        formData.append("file", file); // 文件

        axios.post(
          `https://${signatureData.bucket}.${signatureData.endpoint}`, // OSS 上传地址
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data", // 设置请求头
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              // 上传成功
              const voiceUrl = `https://${signatureData.bucket}.${signatureData.endpoint}/${signatureData.folder}${file.name}`;
              this.fileList = [{ name: file.name, url: voiceUrl, size: file.size }]; // 更新文件列表
              resolve({
                success: true,
                url: voiceUrl  // 返回给上层使用的URL
              });
            } else {
              // 上传失败
              console.error("上传失败：", response);
              reject(new Error("上传失败"));
            }
          })
          .catch((error) => {
            console.error("上传失败：", error);
            reject(error);
          });
      });
    },


    // 确认合成
    async confirmSynthesis() {
      if (!this.selectedImage) {
        this.$message.warning("请先选择一个数字人！");
        return;
      }
      // 修改为统一验证（支持上传或选择）
      if (!this.selectedAudio) {
        this.$message.warning("请先上传或选择一个音频！");
        return;
      }
      this.isLoading = true;
      const startTime = Date.now();
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/create_clone_task.php`, {
          action: "add_video_clone",
          user_id: this.user.id,
          title: this.form.name,
          video_url: this.selectedImage.video_url,
          model: this.selectedImage.model,
          content: this.selectedAudio.content,
          voice_name: this.selectedAudio.title,
          voice_url: this.isCustomAudioUploaded
            ? this.selectedAudio.uploadedUrl  // 使用上传的音频URL
            : this.selectedAudio.voice_clone_url, // 使用预置音频URL
          status: "进行中",
          yd_status: 0,
        });
        if (response.data.success) {
          this.$message.success("合成任务创建成功！");
        } else {
          this.$message.error("合成任务创建失败！");
        }
      } catch (error) {
        console.error("创建合成任务失败:", error);
        this.$message.error("合成任务创建失败！");
      } finally {
        // 计算已消耗的时间
        const elapsed = Date.now() - startTime;
        const remainingTime = 3000 - elapsed;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.isLoading = false;
          }, remainingTime);
        } else {
          this.isLoading = false;
        }
      }
    },
    // 选择音频
    handleVoiceCardClick(index) {

      if (this.isCustomAudioUploaded) {
        ElMessage.warning("已上传自定义音频，请先删除上传音频后再选择");
        return;
      }
      this.audioList.forEach((voice, i) => {
        voice.isSelected = i === index;
      });
      this.selectedAudio = this.audioList[index];

      this.isCustomAudioUploaded = false; // 明确标记为非上传音频

    },
    // 播放/暂停音频
    togglePlay(index) {
      const voice = this.audioList[index];

      // 停止之前播放的音频
      if (this.audioElement) {
        this.audioElement.pause();
        this.audioElement = null;
        this.audioList[this.currentPlayingIndex].isPlaying = false;
      }

      // 播放新的音频
      if (this.currentPlayingIndex !== index) {
        this.audioElement = new Audio(voice.voice_clone_url);
        this.audioElement.play();
        this.currentPlayingIndex = index;
        voice.isPlaying = true;

        // 监听音频结束事件
        this.audioElement.addEventListener("ended", () => {
          voice.isPlaying = false;
          this.currentPlayingIndex = null;
        });
      } else {
        this.currentPlayingIndex = null;
      }
    },
    // 重新上传音频
    handleReupload() {
      this.selectedAudio = null;
      this.isCustomAudioUploaded = false;
      this.fileList = [];
    },
  },
};
</script>



<style scoped>
.create-video-page {
  display: flex;
  height: 100vh;
  background-color: #f8f9fb;
  padding: 0;
  justify-content: space-between;
  align-items: center;
}


.right-panel {
  width: 250px;
  background: #fff;
  border-radius: 0;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  height: 100%;
}

.left-panel {
  width: 360px;
  height: 100vh;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  padding: 24px;
  overflow-y: auto;
}

.panel-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 24px;
  padding-left: 8px;
  position: relative;
}

.panel-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 18px;
  background: #ff5c00;
  border-radius: 2px;
}

.search-bar {
  margin-bottom: 20px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.avatar-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.avatar-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(255, 92, 0, 0.08);
}

.card-inner {
  position: relative;
}

/* 封面样式 */
.cover-wrapper {
  position: relative;
  aspect-ratio: 3/4;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.cover-image.horizontal {
  aspect-ratio: 16/9;
}

.cover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.6) 100%);
  z-index: 1;
}

.preview-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  z-index: 2;
}

.avatar-card:hover .preview-hover {
  opacity: 1;
}

.play-icon {
  color: #fff;
  font-size: 36px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

/* 元信息样式 */
.meta-section {
  padding: 12px;
  background: #fafafa;
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.avatar-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pro-tag {
  font-size: 10px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
  background: linear-gradient(135deg, #ff7e5f, #ff5c00);
}

.free-tag {
  font-size: 10px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
  background: linear-gradient(135deg, #00c6ff, #0072ff);
}

.tech-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.model-type {
  color: #666;
  background: rgba(0, 0, 0, 0.06);
  padding: 2px 6px;
  border-radius: 4px;
}

/* 添加分辨率样式 */
.resolution {
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255, 92, 0, 0.1);
}

.resolution-4K {
  color: #ff5c00;
  background: linear-gradient(45deg, #ff7e5f, #ff5c00);
  color: white;
}

.resolution-2K {
  color: #ff8c00;
  background: linear-gradient(45deg, #ffa500, #ff8c00);
  color: white;
}

.resolution-1080P {
  color: #00c853;
  background: rgba(0, 200, 83, 0.1);
}

.resolution-720P {
  color: #616161;
  background: rgba(97, 97, 97, 0.1);
}

/* 选中状态 */
.selected-mark {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 3;
}

.check-icon {
  color: #ff5c00;
  font-size: 16px;
}

.avatar-card.selected {
  border: 2px solid #ff5c00;
  box-shadow: 0 4px 12px rgba(255, 92, 0, 0.15);
}

.tabs {
  margin-top: 20px;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-button {
  background: #ff5c00;
  border: none;
}


@keyframes bounce {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }
}

.center-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.top-image {
  width: 450px;
  height: 250px;
  overflow: hidden;
  border-radius: 18px 18px 0 0;
}

.top-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.center-panel {
  width: 450px;
  background: #fff;
  border-radius: 18px;
  padding: 30px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  height: auto;
  max-height: 600px;
  margin: 0 20px;
  overflow-y: auto;
}

.el-form-item label {
  font-size: 18px;
}

.upload-container {
  width: 100%;
  text-align: center;
  border: 2px dashed #ff5c00;
  border-radius: 16px;
  padding: 40px;
  background-color: #fff5eb;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: #ff5c00;
}

.upload-icon {
  font-size: 48px;
}

.upload-box p {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
}

.upload-box span {
  font-size: 16px;
  color: #999;
}

.submit-button {
  width: 450px;
  height: 60px;
  background-color: #ff5c00 !important;
  color: #fff !important;
  font-size: 20px;
  font-weight: bold;
  border-radius: 8px;
  border: none;
}

.voice-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.voice-card {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.voice-card.is-selected {
  border-color: #ff5c00;
  background-color: #fff3e0;
}

.voice-card:hover {
  background-color: #f9f9f9;
}

.play-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
}

.voice-info {
  flex: 1;
}

.voice-title {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
}

.voice-tag {
  font-size: 12px;
  color: #888;
  margin: 0;
}

.uploaded-audio {
  text-align: center;
  padding: 20px;

  border-radius: 8px;
}

.reupload-button {
  margin-top: 10px;
  background: #ff5c00;
  border: none;
}
</style>